import { isBrowser } from '@phx-husky/browser-helpers';
import { FC, useEffect, useMemo } from 'react';

import { gtmService } from '~/services/gtm';

import { ElementOnScreenProps } from './model';
import { useElementOnScreen } from './useElementOnScreen';

export const ElementOnScreen: FC<ElementOnScreenProps> = ({
  render: renderParam,
  componentName,
}) => {
  const { containerRef, isVisibleAfterTimeout } = useElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.25,
  });

  const render = useMemo(
    () => renderParam(containerRef),
    [renderParam, containerRef]
  );

  useEffect(() => {
    if (!isVisibleAfterTimeout || !isBrowser()) return;
    gtmService.emitViewElement(componentName);
  }, [isVisibleAfterTimeout, componentName]);

  return render;
};
